import React from 'react';
import { SectionHeading } from './SectionHeading';
import { bonuses, Bonus } from '../data/bonuses';
import { heroImage } from '../data/copy';
import { optimizedImage } from '../utils/image';

/** One mockup download serves every bonus cover, each cropped with CSS. */
const MOCKUP_URL = optimizedImage(heroImage, 1240, 70);
export function BonusesSection() {
  return <section id="bonuses" className="defer-paint w-full scroll-mt-6 bg-navy py-10 sm:py-14" aria-labelledby="bonuses-heading" data-id="element-13" data-mp="qw5wrokyc7wx">
      <div className="mx-auto max-w-5xl px-6" data-id="element-14" data-mp="zv15p8fdrw3x">
        <SectionHeading eyebrow="Included free" title={<span id="bonuses-heading" data-id="element-16" data-mp="1ejx8or2kyixo">+ 5 practical coaching bonuses</span>} lead="Practical tools designed to solve real problems before and during training." data-id="element-15" data-mp="zu7unv9e2kfz" />

        <ul className="mt-8 grid gap-3 md:grid-cols-2 md:gap-4" data-id="element-17" data-mp="19mdv7tdpia6s">
          {bonuses.map((bonus, index) => {
          const isLastOdd = index === bonuses.length - 1 && bonuses.length % 2 === 1;
          return <BonusCard key={bonus.number} bonus={bonus} className={isLastOdd ? 'md:col-span-2 md:mx-auto md:w-[calc(50%-0.5rem)]' : ''} data-id="element-18" data-mp="1jgdydppfh5cv" data-mpi={index} />;
        })}
        </ul>
      </div>
    </section>;
}
interface BonusCardProps {
  bonus: Bonus;
  className?: string;
}

/** Cover (cropped from the product mockup) on the left, details on the right. */
function BonusCard({
  bonus,
  className = ''
}: BonusCardProps) {
  const {
    x,
    y,
    w,
    h
  } = bonus.crop;
  return <li className={`flex min-h-[10.5rem] overflow-hidden rounded-2xl border border-line bg-ink ${className}`} data-id="element-19" data-mp="cj0jguyeqp9n">
      <div className="flex w-[34%] max-w-[9.5rem] shrink-0 items-center justify-center bg-panel p-2.5" data-id="element-20" data-mp="gju9btveue56">
        <div role="img" aria-label={`${bonus.title} cover`} className="w-full rounded-md" style={{
        aspectRatio: `${w} / ${h}`,
        backgroundImage: `url("${MOCKUP_URL}")`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: `${100 / w}% ${100 / h}%`,
        backgroundPosition: `${x / (1 - w) * 100}% ${y / (1 - h) * 100}%`
      }} data-id="element-21" data-mp="lcvq67f6gnre" />
      </div>

      <div className="flex min-w-0 flex-1 flex-col border-l-[3px] px-3.5 py-3 sm:px-4 sm:py-3.5" style={{
      borderColor: bonus.color
    }} data-id="element-22" data-mp="amabq5qteiei">
        <div className="flex items-center gap-2" data-id="element-23" data-mp="5kb6eqbilbex">
          <span className="font-display text-xs font-bold uppercase tracking-[0.16em]" style={{
          color: bonus.color
        }} data-id="element-24" data-mp="kc3lr2bb6pgn">
            Bonus {bonus.number}
          </span>
          <span className="rounded-full bg-cta px-2 py-0.5 font-display text-[0.65rem] font-bold uppercase tracking-[0.12em] text-on-cta" data-id="element-25" data-mp="taxeuipfkxpg">
            Free
          </span>
        </div>
        <h3 className="mt-0.5 font-display text-lg font-extrabold uppercase leading-[1.05] text-fg sm:text-xl" data-id="element-26" data-mp="139mltgfsgxqx">
          {bonus.title}
        </h3>
        {bonus.intro ? <p className="mt-1 text-[0.82rem] leading-snug text-fg/90" data-id="element-27" data-mp="y8qip539hfmk">{bonus.intro}</p> : null}
        {bonus.items ? <p className="mt-1 text-[0.78rem] leading-snug text-muted" data-id="element-28" data-mp="35343lcxmveze">
            {bonus.listLabel ? <span className="font-semibold text-fg/80" data-id="element-29" data-mp="3049b1j9v6c23">{bonus.listLabel} </span> : null}
            {bonus.items.join(' · ')}
          </p> : null}
        <p className="mt-auto pt-1.5 text-[0.8rem] font-semibold leading-snug text-accent" data-id="element-30" data-mp="1kjqhuf5gdy1y">
          {bonus.closingLabel ? `${bonus.closingLabel} ` : ''}
          {bonus.closing.join(' ')}
        </p>
      </div>
    </li>;
}